module.exports = __webpack_public_path__ + "img/dot-unassigned.4c2e809b.svg";